// import React, { useState, useEffect } from "react";
// import { useParams, useHistory } from "react-router-dom";
// import "./createBundle.css";
// import AddModal from "../../components/Modals/AddModal";
// import logoBlue from "../../components/images/logoblue.png";
// import { Delete, Edit, Check, Sync, ArrowBack } from "@material-ui/icons";
// import { createBundle } from "../../services/subscriptions.services.js";
// import { ClockTypesEnum } from "../../components/clockTypesEnum/ClockTypesEnum";

// const initialState = {
//   title: "",
//   features: [
//     {
//       name: "Clock only",
//       description: "Use our clock only version",
//       available: true,
//       slug: ClockTypesEnum.clock_with_stats, // Initial slug value for the first feature
//     },
//   ],
//   price: 0,
//   priceUnit: "dollar",
//   androidProductId: null,
//   iosProductId: null,
//   type: "",
//   displayOrder: 0,
//   numberOfUsage: 0,
// };

// export default function CreateBundle(props) {
//   const [visible, setVisible] = useState(false);

//   const [initialStateForm, setInitialStateForm] = useState(initialState);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [openAddModal, setOpenAddModal] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");

//   const [selectedFeature, setSelectedFeature] = useState("");

//   const [features, setFeatures] = useState([
//     {
//       name: "",
//       description: "",
//       available: true,
//     },
//   ]);

//   const handleFormChange = (name, value) => {
//     if (name === "selectedFeature") {
//       setSelectedFeature(value);
//     } else {
//       setInitialStateForm((prevState) => ({
//         ...prevState,
//         [name]:
//           name === "price" ||
//           name === "displayOrder" ||
//           name === "numberOfUsage"
//             ? parseInt(value) || 0
//             : value,
//       }));
//     }
//   };

//   const handleAddFeature = (e) => {
//     e.preventDefault();
//     setFeatures((prevFeatures) => [
//       ...prevFeatures,
//       {
//         name: "",
//         description: "",
//         available: true,
//         slug: ClockTypesEnum.clock_with_stats, // Set the default slug value for new features
//       },
//     ]);
//   };

//   const handleFeatureChange = (index, key, value) => {
//     setFeatures((prevFeatures) => {
//       const newFeatures = [...prevFeatures];
//       newFeatures[index][key] = value;
//       return newFeatures;
//     });
//   };

//   const handleCreate = async (e) => {
//     e.preventDefault();
//     console.log("created Bundle data", initialStateForm, features);

//     try {
//       setLoading(true);
//       const response = await createBundle(
//         {
//           ...initialStateForm,
//           features: features, // Ensure this is the updated features array
//           selectedFeature: selectedFeature,
//         },
//         JSON.parse(sessionStorage.getItem("myData"))
//       );
//       setSuccessMessage("Bundle has been created Successfully!"); // Set success message
//       setOpenAddModal(true); // Open the success modal
//       window.location.href = "/subscriptionBundles";
//       // Handle the response as needed
//     } catch (e) {
//       setError(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   let history = useHistory();

//   return (
//     <div className="addRule">
//       {openAddModal && (
//         <AddModal
//           closeModal={setOpenAddModal}
//           children="Bundle Added Successfully"
//         />
//       )}
//       <div className="addRuleHeader">
//         <div className="titleWithBack">
//           <button className="backBtn" onClick={() => history.goBack()}>
//             <ArrowBack className="backBtnIcon" />
//           </button>
//           <h1 className="addRuleTitle">Add New Subscription Bundle</h1>
//         </div>
//         <img
//           className="addRuleLogo"
//           src={logoBlue}
//           alt="logo"
//           width="150px"
//         ></img>
//       </div>

//       <form className="addRuleForm">
//         <div className="ruleNameCodeBox">
//           <div className="addRuleItem">
//             <input
//               type="text"
//               placeholder="Bundle Name"
//               value={initialStateForm.title}
//               onChange={(e) => handleFormChange("title", e.target.value)}
//             />
//           </div>
//           <div className="addRuleItem">
//             <input
//               className="input"
//               placeholder="Bundle Price (USD)"
//               type="number"
//               onChange={(e) => handleFormChange("price", e.target.value)}
//             />
            
//           </div>
//         </div>

//         {features.map((feature, index) => (
//           <div className="addFeatureItem" key={index}>
//             <input
//               type="text"
//               placeholder="Feature Name"
//               value={feature.name}
//               onChange={(e) =>
//                 handleFeatureChange(index, "name", e.target.value)
//               }
//             />
//             <input
//               type="text"
//               placeholder="Feature Description"
//               value={feature.description}
//               onChange={(e) =>
//                 handleFeatureChange(index, "description", e.target.value)
//               }
//             />
//             <label style={{ marginLeft: "5px", marginRight: "10px" }}>
//               Available
//               <input
//                 style={{ marginLeft: "6px", marginTop: "7px" }}
//                 type="checkbox"
//                 checked={feature.available}
//                 onChange={(e) =>
//                   handleFeatureChange(index, "available", e.target.checked)
//                 }
//               />
//             </label>
//             <label style={{ marginLeft: "10px" }}>
//               Slug
//               <select
//                 className="inputSlugDropDown"
//                 style={{ marginLeft: "10px" }}
//                 value={feature.slug}
//                 onChange={(e) =>
//                   handleFeatureChange(index, "slug", e.target.value)
//                 }
//               >
//                 {Object.values(ClockTypesEnum).map((clockType, enumIndex) => (
//                   <option
//                     className="inputSlug"
//                     key={enumIndex}
//                     value={clockType}
//                   >
//                     {clockType}
//                   </option>
//                 ))}
//               </select>
//             </label>
//             {/* Add more fields as needed */}
//           </div>
//         ))}

//         <button
//           className="addFeatureButton"
//           onClick={(e) => handleAddFeature(e)}
//         >
//           Add Feature
//         </button>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Android Product Id :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("androidProductId", e.target.value)
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">iOS Product Id :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) => handleFormChange("iosProductId", e.target.value)}
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Type :</h4>
//           <input
//             className="input"
//             type="text"
//             onChange={(e) => handleFormChange("type", e.target.value)}
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Display Order :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("displayOrder", parseInt(e.target.value))
//             }
//           />
//         </div>

//         <div className="addRuleView">
//           <h4 className="addRuleTxt">Number Of Usage :</h4>
//           <input
//             className="input"
//             type="number"
//             onChange={(e) =>
//               handleFormChange("numberOfUsage", parseInt(e.target.value))
//             }
//           />
//         </div>

//         <button className="addRuleButton" onClick={handleCreate}>
//           Create
//         </button>
//       </form>
//     </div>
//   );
// }


import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './createBundle.css';
import AddModal from '../../components/Modals/AddModal';
import logoBlue from '../../components/images/logoblue.png';
import { ArrowBack } from '@material-ui/icons';
import { createBundleAction } from '../../redux/actions/bundleActions.js';
import { ClockTypesEnum } from '../../components/clockTypesEnum/ClockTypesEnum';

const initialState = {
  title: '',
  features: [
    {
      name: 'Clock only',
      description: 'Use our clock only version',
      available: true,
      slug: ClockTypesEnum.clock_with_stats,
    },
  ],
  price: 0,
  priceUnit: 'dollar',
  androidProductId: null,
  iosProductId: null,
  type: '',
  displayOrder: 0,
  numberOfUsage: 0,
};

export default function CreateBundle(props) {
  const [visible, setVisible] = useState(false);
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [error, setError] = useState(null);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [selectedFeature, setSelectedFeature] = useState('');
  const [features, setFeatures] = useState([
    {
      name: '',
      description: '',
      available: true,
    },
  ]);

  const dispatch = useDispatch();
  const history = useHistory();

  const handleFormChange = (name, value) => {
    if (name === 'selectedFeature') {
      setSelectedFeature(value);
    } else {
      setInitialStateForm((prevState) => ({
        ...prevState,
        [name]:
          name === 'price' ||
          name === 'displayOrder' ||
          name === 'numberOfUsage'
            ? parseInt(value) || 0
            : value,
      }));
    }
  };

  const handleAddFeature = (e) => {
    e.preventDefault();
    setFeatures((prevFeatures) => [
      ...prevFeatures,
      {
        name: '',
        description: '',
        available: true,
        slug: ClockTypesEnum.clock_with_stats,
      },
    ]);
  };

  const handleFeatureChange = (index, key, value) => {
    setFeatures((prevFeatures) => {
      const newFeatures = [...prevFeatures];
      newFeatures[index][key] = value;
      return newFeatures;
    });
  };

  const handleCreate = (e) => {
    e.preventDefault();
    dispatch(createBundleAction({ ...initialStateForm, features, selectedFeature }));
    setSuccessMessage('Bundle has been created Successfully!');
    setOpenAddModal(true);
    history.push('/subscriptionBundles');
  };

  const { loading, bundle, error: reduxError } = useSelector(
    (state) => state.bundle
  );

  return (
    <div className="addRule">
      {openAddModal && (
        <AddModal closeModal={setOpenAddModal}>
          Bundle Added Successfully
        </AddModal>
      )}
      <div className="addRuleHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="addRuleTitle">Add New Subscription Bundle</h1>
        </div>
        <img
          className="addRuleLogo"
          src={logoBlue}
          alt="logo"
          width="150px"
        />
      </div>

      <form className="addRuleForm">
        <div className="ruleNameCodeBox">
          <div className="addRuleItem">
            <input
              type="text"
              placeholder="Bundle Name"
              value={initialStateForm.title}
              onChange={(e) => handleFormChange('title', e.target.value)}
            />
          </div>
          <div className="addRuleItem">
            <input
              className="input"
              placeholder="Bundle Price (USD)"
              type="number"
              onChange={(e) => handleFormChange('price', e.target.value)}
            />
          </div>
        </div>

        {features.map((feature, index) => (
          <div className="addFeatureItem" key={index}>
            <input
              type="text"
              placeholder="Feature Name"
              value={feature.name}
              onChange={(e) =>
                handleFeatureChange(index, 'name', e.target.value)
              }
            />
            <input
              type="text"
              placeholder="Feature Description"
              value={feature.description}
              onChange={(e) =>
                handleFeatureChange(index, 'description', e.target.value)
              }
            />
            <label style={{ marginLeft: '5px', marginRight: '10px' }}>
              Available
              <input
                style={{ marginLeft: '6px', marginTop: '7px' }}
                type="checkbox"
                checked={feature.available}
                onChange={(e) =>
                  handleFeatureChange(index, 'available', e.target.checked)
                }
              />
            </label>
            <label style={{ marginLeft: '10px' }}>
              Slug
              <select
                className="inputSlugDropDown"
                style={{ marginLeft: '10px' }}
                value={feature.slug}
                onChange={(e) =>
                  handleFeatureChange(index, 'slug', e.target.value)
                }
              >
                {Object.values(ClockTypesEnum).map((clockType, enumIndex) => (
                  <option
                    className="inputSlug"
                    key={enumIndex}
                    value={clockType}
                  >
                    {clockType}
                  </option>
                ))}
              </select>
            </label>
          </div>
        ))}

        <button className="addFeatureButton" onClick={(e) => handleAddFeature(e)}>
          Add Feature
        </button>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Android Product Id :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) =>
              handleFormChange('androidProductId', e.target.value)
            }
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">iOS Product Id :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) =>
              handleFormChange('iosProductId', e.target.value)
            }
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Type :</h4>
          <input
            className="input"
            type="text"
            onChange={(e) => handleFormChange('type', e.target.value)}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Display Order :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) =>
              handleFormChange('displayOrder', parseInt(e.target.value))
            }
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Number Of Usage :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) =>
              handleFormChange('numberOfUsage', parseInt(e.target.value))
            }
          />
        </div>

        <button className="addRuleButton" onClick={handleCreate}>
          Create
        </button>
      </form>
    </div>
  );
}
